import { render, staticRenderFns } from "./PrimaryContactForm.vue?vue&type=template&id=b9239246"
import script from "./PrimaryContactForm.vue?vue&type=script&lang=js"
export * from "./PrimaryContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports